export type ClientViewModeInput = {
  is_active?: boolean | number | string | null;
  was_activated?: boolean | number | string | null;
};

/** Map client record to Clients page tab (active / inactive / new). */
export function getClientViewMode(client: ClientViewModeInput): 'active' | 'inactive' | 'new' {
  const isActive =
    client.is_active === true ||
    client.is_active === 1 ||
    client.is_active === '1';

  if (isActive) {
    return 'active';
  }

  const wasActivated = client.was_activated;

  if (wasActivated === 1 || wasActivated === true || wasActivated === '1') {
    return 'inactive';
  }

  if (
    wasActivated === 0 ||
    wasActivated === false ||
    wasActivated === '0' ||
    wasActivated === null
  ) {
    return 'new';
  }

  // Inactive client but field missing from payload — default to inactive (not new)
  return 'inactive';
}
